import { getDocument } from './getDocument.js';

/**
 * Returns `element.ownerDocument.activeElement`.
 */

function getActiveElement(element) {
  return getDocument(element).activeElement;
}

export { getActiveElement };
